export const ThemeTypes = {
  Light: "light",
  Dark: "dark"
};
